import moment from 'moment';
import useFetchHomeLatestData from 'Pages/Blog/Hooks/useFetchHomeLatestData';
import React from 'react';
import KickImage from 'Reuseables/KickImage';
import ListItem from '../../Molecules/ListItem';

import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import { TextBlock, RectShape } from 'react-placeholder/lib/placeholders';

import { IListProps } from './List.definitions';

/** CSS import */
import Styles from './List.module.scss';

const List: React.FC<IListProps> = ({}: IListProps) => {
  const { fetchLatestData, data, isError, isFetching, error } =
    useFetchHomeLatestData();

  React.useEffect(() => {
    fetchLatestData();
  }, []);

  const Placeholder = React.useMemo(
    () => (
      <div className={Styles['placeholder']}>
        {[...Array(8)].map((_, index) => (
          <div className={Styles['placeholder-item']}>
            <RectShape
              color="#eeeeee"
              className={Styles['image-placeholder']}
            />
            <TextBlock rows={3} color="#eeeeee" />
          </div>
        ))}
      </div>
    ),
    [],
  );

  return (
    <div className={Styles['wrapper']}>
      <ReactPlaceholder ready={!isFetching} customPlaceholder={Placeholder}>
        {data.map((item, index) => (
          <ListItem
            key={`features-article-${item.slug}-${index}`}
            title={item.title}
            date={moment(item.created_at).format('MMMM DD, YYYY')}
            image={item.thumbnail?.URL ?? 'https://picsum.photos/500'}
            link={`/kickavenews/${item.slug}`}
          />
        ))}
      </ReactPlaceholder>
    </div>
  );
};

export default List;
